import { NgModule, ApplicationRef } from '@angular/core';

import { CLPBPAppComponent } from './clpbp-app.component';
import { imports } from './imports';
import { declarations } from './declarations';
import { providers } from './providers';

@NgModule({
  declarations,
  imports,
  providers: providers,
  bootstrap: [ CLPBPAppComponent ]
})
export class CLPBPAppModule {

  constructor(public appRef: ApplicationRef) {}
}
